<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <form>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>标题：</label>
              <div class="col-lg-6">
                <input v-model="dataInfo.titleQa" type="text" class="form-control" maxlength="30" placeholder="请输入1~30个字"/>
              </div>
            </div>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>短标题：</label>
              <div class="col-lg-6">
                <input v-model="dataInfo.subTitle" type="text" class="form-control" maxlength="14" placeholder="请输入1~14个字"/>
              </div>
            </div>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>活动时间：</label>
              <div class="col-lg-6">
                <date-picker v-model="dateRange" placeholder="输入日期2021-09-11 12:11:11" type="datetime" range value-type='format' format="YYYY-MM-DD HH:mm:ss"
                             :minute-step=1 confirm></date-picker>
              </div>
              <div class="col-lg-2 hi_center">
                <b-form-checkbox v-model="dataInfo.longState" value="1" unchecked-value="0" checked plain>长期有效</b-form-checkbox>
              </div>
            </div>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>答题时间：</label>
              <div class="col-lg-6">
                <date-picker v-model="qaDateRange" placeholder="输入日期2021-09-11 12:11:11" type="datetime" range value-type='format' format="YYYY-MM-DD HH:mm:ss"
                             :minute-step=1 confirm></date-picker>
              </div>
            </div>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>状态：</label>
              <div class="col-lg-1 hi_center">
                <b-form-radio name="qstatus" v-model="dataInfo.status" value='1' plain>下架</b-form-radio>
              </div>
              <div class="col-lg-1 hi_center">
                <b-form-radio name="qstatus" v-model="dataInfo.status" value='2' plain>上架</b-form-radio>
              </div>
            </div>

            <div class="form-group row mb-3">
                <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>封面图：</label>
                <div class="col-lg-5">
                  <image-upload isShowDel size="4:3" :maxSize="2" ref="imageQa"></image-upload>
                  <p style="color: #C0C4CC; font-size: 13px; margin: 0">图片比例4:3，建议尺寸670 * 500 px，建议文件小于1M</p>
                </div>

                <label class="col-form-label col-lg-1 input_text">背景图：</label>
                <div class="col-lg-4">
                  <image-upload isShowDel size="4:3" :maxSize="2" ref="backgroundImage"></image-upload>
                  <p style="color: #C0C4CC; font-size: 13px; margin: 0">建议尺寸750 * 1624 px，建议文件小于1M</p>
                </div>
            </div>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>背景文案：</label>
              <div class="col-lg-3 hi_center">
                <b-form-radio name="backgroundContentType" v-model="dataInfo.backgroundContentType" :value='0' plain>默认文案</b-form-radio>
              </div>
              <div class="col-lg-3 hi_center">
                <b-form-radio name="backgroundContentType" v-model="dataInfo.backgroundContentType" :value='1' plain>自定义文案</b-form-radio>
              </div>
            </div>

            <template v-for="(item, key) in ContentTypeObj">
              <div class="form-group row mb-3" v-show="key == dataInfo.backgroundContentType" :key="key">
                <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>标题文案：</label>
                <div class="col-lg-5">
                  <input :disabled="key == 0"
                    v-model="item.contentTitleOne" type="text" class="form-control" maxlength="6" placeholder="请输入第一行，最多6字"/><br/>
                  <input :disabled="key == 0"
                    v-model="item.contentTitleTwo" type="text" class="form-control" maxlength="6" placeholder="请输入第二行，最多6字"/>
                </div>
                <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>规则文案：</label>
                <div class="col-lg-4 hi_center">
                  <textarea :disabled="key == 0" style="height: 100%;"
                    v-model="item.contentRule" type="text" class="form-control" maxlength="40" placeholder="请输入规则，最多40字"/>
                </div>
              </div>
            </template>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>添加问答：</label>
              <div class="col-lg-4">
                <button type="button" class="btn btn-primary m-r-20" @click="selectQuestion()">
                  <i class="bx bx-plus font-size-16 align-middle me-2"></i>添加
                </button>
              </div>
            </div>
            <div class="form-group row mb-3" v-if="checkQa.length > 0">
              <label class="col-form-label col-lg-1 input_text"></label>
              <div class="col-lg-10">
                <div class="table-responsive-main-list">
                  <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 70px;">ID</th>
                          <th scope="col">名称</th>
                          <th scope="col">封面</th>
                          <th scope="col">题目数</th>
                          <th scope="col">标签</th>
                          <th scope="col">使用次数</th>
                          <th scope="col">创建日期</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in checkQa" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>{{ item.title }}</td>
                          <td>
                            <img v-if="item.image" class="avatar-sm" :src="`${item.image}`" alt />
                            <img v-if="!item.image" class="avatar-sm" src="../../../assets/images/image-null.jpg" alt="">
                          </td>
                          <td>{{item.questionNum || 0}}</td>
                          <td>
                            <template v-if="item.tag">{{item.tag.split(",").length}}</template>
                            <template v-else>0</template>
                          </td>
                          <td>{{ item.userNum || 0 }}</td>
                          <td>{{ item.createAt || '--' }}</td>
                          <td>
                            <ul class="list-inline font-size-22 contact-links mb-0">
                              <li class="list-inline-item px-2" @click="removeQa()">
                                <a v-b-tooltip.hover title="删除">
                                  <i class="bx bx-trash"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>类型：</label>
              <div class="col-lg-11 hi_center">
                <b-form-radio :disabled="dataInfo.disabledType"  name="prizeType" v-model="dataInfo.qaRewardType" value='coupon' plain>优惠券</b-form-radio>
                <b-form-radio :disabled="dataInfo.disabledType"  style="margin-left: 30px;" name="prizeType" v-model="dataInfo.qaRewardType" value='redPacket' plain>红包</b-form-radio>
              </div>
              <!-- <div class="col-lg-1 hi_center">
                  <b-form-radio name="prizeType" v-model="dataInfo.qaRewardType" value='' plain disabled>红包</b-form-radio>
                </div> -->
            </div>

            <!-- 奖品优惠券 -->
            <div v-if="dataInfo.qaRewardType == 'coupon'" class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"><font color="red">*</font>奖品优惠券：</label>
              <div class="col-lg-4">
                <button type="button" class="btn btn-primary m-r-20" @click="selectCoupon()">
                  <i class="bx bx-plus font-size-16 align-middle me-2"></i>添加优惠券
                </button>
              </div>
            </div>
            <div v-if="dataInfo.qaRewardType == 'coupon'" class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text"></label>
              <div class="col-lg-10">
                <div class="table-responsive-main-list">
                  <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 70px;">ID</th>
                          <th scope="col">名称</th>
                          <th scope="col">类型</th>
                          <th scope="col">可用库存</th>
                          <th scope="col">发放量</th>
                          <th scope="col">核销量</th>
                          <th scope="col">创建时间</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in checkCoupon" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>{{ item.title }}</td>
                          <td>
                            <template v-if="item.couponType == 1">代金券</template>
                            <template v-if="item.couponType == 2">折扣券</template>
                            <template v-if="item.couponType == 3">通用券</template>
                          </td>
                          <td>{{ item.quantity || '--' }}</td>
                          <td>{{ item.grantNumber || '--' }}</td>
                          <td>{{ item.verifyNumber || '0' }}</td>
                          <td>
                            {{ item.createAt || '0' }}
                          </td>
                          <td>
                            <ul class="list-inline font-size-22 contact-links mb-0">
                              <li class="list-inline-item px-2" @click="removeCoupon()">
                                <a v-b-tooltip.hover title="删除">
                                  <i class="bx bx-trash"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mb-3" v-if="dataInfo.qaRewardType == 'redPacket'">
              <label class="col-form-label col-lg-1 input_text"></label>
              <div class="col-lg-11">
                <div>
                  <div class="dsply-fix">
                    <div style="padding-top: 10px;">
                      <el-radio :disabled="dataInfo.disabledType" v-model="dataInfo.redPacket.type" label="0">平分</el-radio>
                      <el-radio :disabled="dataInfo.disabledType" v-model="dataInfo.redPacket.type" label="1">拼手气</el-radio>
                    </div>
                    <div class="dsply-fix" style="margin-left: 15px">
                      <span style="padding-top: 10px;">份数：</span>
                      <input
                        style="width: 100px;"
                        v-model="dataInfo.redPacket.total"
                        :disabled="dataInfo.disabledType"
                        type="text"
                        class="form-control"
                        placeholder="整数"
                      />
                    </div>
                    <div class="dsply-fix" style="margin-left: 15px">
                      <span style="padding-top: 10px;">红包点数：</span>
                      <input
                        style="width: 100px;"
                        :disabled="dataInfo.disabledType"
                        v-model="dataInfo.redPacket.totalAmount"
                        type="text"
                        class="form-control"
                        placeholder="0.00"
                      />
                    </div>
                    <div style="padding-top: 10px;margin-left: 15px">可用点数：{{ pointTotal }}，每份红包不得小于0.3</div>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-1 input_text">门店：</label>
              <div class="col-lg-4">
                <button type="button" class="btn btn-primary m-r-20" @click="addShop()">
                  <i class="bx bx-plus font-size-16 align-middle me-2"></i>添加
                </button>
              </div>
            </div>

            <div class="form-group row mb-3" v-if="checkShops.length > 0">
              <label class="col-form-label col-lg-1 input_text"></label>
              <div class="col-lg-10">
                <div class="table-responsive-main-list">
                  <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 70px;">ID</th>
                          <th scope="col">门店名称</th>
                          <th scope="col">地址</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in checkShops" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.address }}</td>
                          <td>
                            <ul class="list-inline font-size-22 contact-links mb-0">
                              <li class="list-inline-item px-2" @click="removeShop(item)">
                                <a v-b-tooltip.hover title="删除">
                                  <i class="bx bx-trash"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </form>

          <div class="row submit-bar">
            <div class="col-md-12">
              <div class="bar-handle">
                <router-link to="/question">
                  <button class="btn-sm btn btn-outline-dark" type="button">取消</button>
                </router-link>
                <button class="btn-sm btn btn-primary" type="button" @click="publish()">发布</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coupon-dialog @pageCallback="pageCallback" ref="coupon"></coupon-dialog>
    <qa-dialog @pageCallback="pageCallback" ref="qa"></qa-dialog>
    <shop-dialog @pageCallback="pageCallback" ref="shop"></shop-dialog>
  </div>
</template>


<script>
import Vue from "vue";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import question from "../../../server/api/question";
import couponDialog from "./coupon.vue";
import qaDialog from "./question.vue";
import shopDialog from "./shops.vue";
import content from '../../../server/api/videoPublish'

import imageUpload from '@/components/imageUpload-tw'

export default {
  components: {
    DatePicker,
    couponDialog,
    qaDialog,
    shopDialog,
    imageUpload,
  },
  created() {},
  mounted() {
    const id = this.$route.query.id;
    this.getRedPacketInfo()
    if (id) {
      this.dataInfo.id = id;
      this.editable = true;
      this.$nextTick(() => {
        this.getInfo()
      })
    }
  },
  data() {
    return {
      editable: false,
      show: true,
      dataInfo: {
        merchantId: 1,
        id: 0,
        qaRewardType: "coupon",
        qaReward: "",
        indexId: "",
        merchantName: "",
        storeId: 0,
        storeName: "",
        longState: 0,
        startTime: "",
        endTime: "",
        status: "1",
        backgroundContentType: 0,
        titleQa: "",
        subTitle: "",
        stores: [],
        redPacket: {},
        contentRule: "",
        contentTitleOne: "",
        contentTitleTwo: "",
      },
      ContentTypeObj: {
        0: {
          contentRule: "答对得10分，答错得0分，总分超过40分可获得惊喜奖品，每场问答仅可领奖1次。",
          contentTitleOne: "天天答题",
          contentTitleTwo: "赢取丰厚奖励",
        },
        1: {
          contentRule: "",
          contentTitleOne: "",
          contentTitleTwo: "",
        }
      },
      dateRange: [],
      qaDateRange: [],
      checkCoupon: [],
      checkQa: [],
      checkShops: [],
      pointTotal: 0
    };
  },
  methods: {

    getRedPacketInfo(){
      content.redPacketInfo().then(resp => {
        if(resp.data){
          // leftAmount 单位为分。所以需要/100
          this.pointTotal = parseFloat(resp.data.leftAmount / 100).toFixed(2)
        }
      })
    },

    // 查询详情
    async getInfo() {
      console.log(this.dataInfo.id);
      await question.detail({ id: this.dataInfo.id }).then((resp) => {
        console.log(resp);
        resp.data.disabledType = true
        if(resp.data.couponId){
          // resp.data.qaRewardType = "coupon"
          this.getConpons(resp.data.couponId)
        } else {
          if(resp.data.redPacket){
            if(resp.data.redPacket.id){
              // resp.data.redPacket.disabledType = true
              // resp.data.qaRewardType = "redPacket"
              resp.data.redPacket.type = resp.data.redPacket.type.toString()
              resp.data.redPacket.totalAmount = parseFloat(resp.data.redPacket.totalAmount / 100)
            }
          } else {
            resp.data.redPacket = {}
            // resp.data.redPacket.disabledType = false
          }
        }
        this.dataInfo = resp.data;
        if (!this.dataInfo.longState) {
          this.dataInfo.longState = 0;
        }
        if (this.dataInfo.startTime) {
          this.dateRange.push(this.dataInfo.startTime);
        }
        if (this.dataInfo.endTime) {
          this.dateRange.push(this.dataInfo.endTime);
        }

        const qaDateRange = []
        if (this.dataInfo.qaStartTime) {
          qaDateRange.push(this.dataInfo.qaStartTime);
        }
        if (this.dataInfo.qaEndTime) {
          qaDateRange.push(this.dataInfo.qaEndTime);
        }
        this.qaDateRange = qaDateRange

        this.$refs.imageQa.setImageUrl(this.dataInfo.imageQa)
        this.$refs.backgroundImage.setImageUrl(this.dataInfo.backgroundImage)

        this.dataInfo.backgroundContentType = Number(this.dataInfo.backgroundContentType ? this.dataInfo.backgroundContentType : 0)

        this.ContentTypeObj[this.dataInfo.backgroundContentType].contentRule = this.dataInfo.contentRule
        this.ContentTypeObj[this.dataInfo.backgroundContentType].contentTitleOne = this.dataInfo.contentTitleOne
        this.ContentTypeObj[this.dataInfo.backgroundContentType].contentTitleTwo = this.dataInfo.contentTitleTwo

        if (this.dataInfo.qaReward) {
          this.checkCoupon.push(JSON.parse(this.dataInfo.qaReward));
        }
        if (this.dataInfo.stores) {
          this.checkShops = this.dataInfo.stores;
        }
        this.checkQa.push({
          id: this.dataInfo.indexId,
          title: this.dataInfo.title,
          image: this.dataInfo.image,
          questionNum: this.dataInfo.qaBankList.length,
          tag: this.dataInfo.tag,
          userNum: this.dataInfo.userNum,
          createAt: this.dataInfo.createTimeStr,
        });
      });
    },

    // 新增、修改
    publish() {
      let flag = this.resetSubmitInfo();
      if (!flag) {
        return;
      }
      const dataInfo = JSON.parse(JSON.stringify(this.dataInfo))
      dataInfo.qaEndTime = this.qaDateRange[1]
      dataInfo.qaStartTime = this.qaDateRange[0]
      dataInfo.contentRule = this.ContentTypeObj[this.dataInfo.backgroundContentType].contentRule
      dataInfo.contentTitleOne = this.ContentTypeObj[this.dataInfo.backgroundContentType].contentTitleOne
      dataInfo.contentTitleTwo = this.ContentTypeObj[this.dataInfo.backgroundContentType].contentTitleTwo
      dataInfo.backgroundImage = this.$refs.backgroundImage.getImageUrl()
      dataInfo.imageQa = this.$refs.imageQa.getImageUrl()

      if (this.dataInfo.longState != 1) {
        if (new Date(dataInfo.qaStartTime).getTime() < new Date(dataInfo.startTime).getTime()) {
          return Vue.swal("答题开始时间不能小于活动开始时间")
        }
        if (new Date(dataInfo.qaEndTime).getTime() > new Date(dataInfo.endTime).getTime()) {
          return Vue.swal("答题结束时间不能大于活动结束时间")
        }
      }
      if (this.dataInfo.id > 0) {
        question
          .update(dataInfo)
          .then((resp) => {
            if (resp) {
              Vue.swal({
                icon: resp.code > 0 ? "error" : "success",
                title: resp.msg,
                showConfirmButton: false,
                timer: 1500,
              });
              if (resp.code === 0) {
                this.$router.push({
                  name: "question",
                });
              }
            }
          })
          .catch((ex) => {
            Vue.swal({
              icon: "error",
              title: ex.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          });
      } else {
        question
          .add(dataInfo)
          .then((resp) => {
            console.log(resp);
            if (resp) {
              Vue.swal({
                icon: resp.code > 0 ? "error" : "success",
                title: resp.msg,
                showConfirmButton: false,
                timer: 1500,
              });
              if (resp.code <= 0) {
                this.$router.push({
                  name: "question",
                });
              } else {
                return;
              }
            }
          })
          .catch((ex) => {
            Vue.swal({
              icon: "error",
              title: ex.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          });
      }
    },

    pageCallback(obj) {
      if (obj.code == "coupon") {
        if (obj.item) {
          this.checkCoupon = [];
          this.checkCoupon.push(obj.item);
        }
      } else if (obj.code == "qa") {
        if (obj.item) {
          this.checkQa = [];
          this.checkQa.push(obj.item);
        }
      } else if (obj.code == "shop") {
        if (obj.item) {
          console.log(obj);
          let items = obj.item;
          const checkItems = this.checkShops;

          if (checkItems && checkItems.length > 0) {
            console.log(1111111);
            items.forEach((element) => {
              let flag = false;
              for (let index = 0; index < this.checkShops.length; index++) {
                const itm = this.checkShops[index];
                if (itm.id == element.id) {
                  flag = true;
                  break;
                }
              }
              if (!flag) {
                this.checkShops.push(element);
              }
            });
          } else {
            console.log(2222222);
            items.forEach((element) => {
              this.checkShops.push(element);
            });
          }
          console.log(this.checkShops);
        }
      }
    },
    resetSubmitInfo() {
      const dataInfo = JSON.parse(JSON.stringify(this.dataInfo))
      if (!dataInfo.titleQa) {
        Vue.swal("请填标题")
        return false;
      }

      if (!dataInfo.subTitle) {
        Vue.swal("请填短标题")
        return false;
      }

      if (
        this.dataInfo.longState == 0 &&
        this.dateRange &&
        this.dateRange.length > 0
      ) {
        this.dataInfo.startTime = this.dateRange[0];
        this.dataInfo.endTime = this.dateRange[1];
      } else if (this.dataInfo.longState == 1) {
        this.dataInfo.startTime = this.utils.getTimeStamp(new Date().getTime() / 1000);
        this.dataInfo.endTime = this.utils.getTimeStamp(new Date().getTime() / 1000 + 60 * 60 * 24 * 31 * 12 * 10);
      } else {
        Vue.swal("请选择活动时间");
        return false;
      }

      dataInfo.qaEndTime = this.qaDateRange[1]
      dataInfo.qaStartTime = this.qaDateRange[0]
      if (!dataInfo.qaStartTime && !dataInfo.qaEndTime) {
        Vue.swal("请填写答题时间")
        return false;
      }

      if (!this.$refs.imageQa.getImageUrl()) {
        Vue.swal("请上传封面图")
        return false;
      }

      if (!this.ContentTypeObj[this.dataInfo.backgroundContentType].contentRule) {
        Vue.swal("请填文案规则")
        return false;
      }

      if (!this.ContentTypeObj[this.dataInfo.backgroundContentType].contentTitleOne && !this.ContentTypeObj[this.dataInfo.backgroundContentType].contentTitleTwo) {
        Vue.swal("请填标题文案")
        return false;
      }

      if (this.checkQa && this.checkQa.length > 0) {
        this.dataInfo.indexId = this.checkQa[0].id;
      } else {
        Vue.swal("请选择问题");
        return false;
      }

      if(this.dataInfo.qaRewardType){
        // params.rewardType = 0优惠券
        if(this.dataInfo.qaRewardType == "coupon"){
          if (this.checkCoupon && this.checkCoupon.length >= 1) {
            this.dataInfo.qaReward = JSON.stringify(this.checkCoupon[0]);
          }else{
            Vue.swal("请选择优惠券");
            return false;
          }
          delete this.dataInfo.redPacket
        }

        if(this.dataInfo.qaRewardType == "redPacket"){
          if(!this.dataInfo.redPacket.type){
            Vue.swal("请选择红包类型");
            return false;
          }
          if(this.dataInfo.redPacket.total){
            if(Math.floor(this.dataInfo.redPacket.total) != this.dataInfo.redPacket.total){
              Vue.swal("红包份数只能输入整数");
              return false;
            }
          } else {
            Vue.swal("请输入红包份数");
            return false;
          }
          if(this.dataInfo.redPacket.totalAmount){
            let totalAmount = Number(this.dataInfo.redPacket.totalAmount)
            let total = Number(this.dataInfo.redPacket.total)
            let pointTotal = Number(this.pointTotal)
            if(pointTotal < totalAmount){
              Vue.swal("当前可用点数不足");
              return false;
            }
            if(totalAmount < total * 0.3){
              Vue.swal("每份红包点数不得小于0.3");
              return false;
            }
            // 后台单位为分。此处*100
            this.dataInfo.redPacket.totalAmount = totalAmount * 100
          } else {
            Vue.swal("请输入红包点数");
            return false;
          }
          delete this.dataInfo.qaReward
        }
      } else {
        delete this.dataInfo.redPacket
        delete this.dataInfo.qaReward
      }

      if (this.checkShops) {
        this.dataInfo.stores = this.checkShops;
      }
      return true;
    },
    selectCoupon() {
      this.$refs.coupon.showModel();
    },
    removeCoupon() {
      this.checkCoupon = [];
    },
    selectQuestion() {
      this.$refs.qa.showModel();
    },
    removeQa() {
      this.checkQa = [];
    },
    addShop() {
      this.$refs.shop.showModel();
    },
    removeShop(item) {
      let newShops = [];
      if (this.checkShops) {
        for (let index = 0; index < this.checkShops.length; index++) {
          const element = this.checkShops[index];
          if (element.id == item.id) {
            continue;
          }
          newShops.push(element);
        }
      }
      this.checkShops = newShops;
    },
  },
};
</script>

<style scoped>
.input_text {
  text-align: right;
  padding-right: 0px;
}
.hi_center {
  display: flex;
  align-items: center;
}
.simplebar_tags {
  overflow: auto;
  display: inline-block;
  max-height: 200px;
  width: 100%;
  height: 100%;
}
</style>

